import { createSlice } from '@reduxjs/toolkit';

export const filtersSlice = createSlice({
	name: 'filters',
	initialState: {
		sortBy: 'Start/Asc',
		filters: {
			Active: true,
			Ready: true,
			Finished: true,
		},
		searchQuery: '',
	},
	reducers: {
		setSortBy: (state, action) => {
			state.sortBy = action.payload;
		},
		setFilters: (state, action) => {
			state.filters = action.payload;
		},
		setQuery: (state, action) => {
			state.searchQuery = action.payload;
		},
	},
});

export const { setSortBy, setFilters, setQuery } = filtersSlice.actions;

export default filtersSlice.reducer;
